import { defineStore } from 'pinia';
import { useForm } from '@/composables/form.ts';
import { httpService } from '@/core';
import { subscriptionIndexUrl } from '@/api/subscription';

export const useSubscriptionStore = defineStore('subscription', {
  state: () => ({
    companies: [],
    list: [],
    durations: [],
    paymentMethods: [],
    allowed_subscriptions: [],
    allowed_periods: [],
    allowed_payment_methods: [],
    selected: null,
    discount: null,
    loading: true,
    loaded: false,
    modalVisible: false,
    showComparison: false,
    latest_payments: [],
    payment_method_details: null,
    payment_cards: [],
    default_payment_method_id: null,
    recurring_subscription: null,
    stripe_subscription: null,
    upcoming_invoice: null,
    remaining_value: null,
    stripe_balance: null,
    stripe_enabled: false,
    stripe_company_id: null,
    show_discount: false,
    form: useForm({
      subscription: 'business',
      company: null,
      duration: 12,
      payment: 'recurring',
      discount: null,
      buy_for_company_id: null,
    }),
    manual_payments: true,
    vat_code: null,
    vat_percent: null,
    vat_tariff: null,
    pricing_version: null
  }),

  actions: {
    setList(payload) {
      this.list = payload;
    },

    setDuration(payload) {
      this.durations = payload;
    },

    setLoaded(payload) {
      this.loaded = payload;
    },

    setLoading(payload) {
      this.loading = payload;
    },

    select(payload) {
      this.selected = payload;
      this.form.$.subscription = payload.tag;
    },

    setDiscount(payload) {
      this.discount = payload;
    },

    setModalVisible(payload) {
      this.modalVisible = payload;
    },

    setShowComparison(payload) {
      this.showComparison = payload;
    },

    setLatestPayments(payload) {
      this.latest_payments = payload;
    },

    setPaymentDetails(payload) {
      this.payment_method_details = payload;
    },

    setPaymentCards(payload) {
      this.payment_cards = payload;
    },

    setDefaultPaymentMethodId(payload) {
      this.default_payment_method_id = payload;
    },

    setRecurringSubscription(payload) {
      this.recurring_subscription = payload;
    },

    setRemainingValue(payload) {
      this.remaining_value = payload;
    },

    setStripeSubscription(payload) {
      this.stripe_subscription = payload;
    },

    setUpcomingInvoice(payload) {
      this.upcoming_invoice = payload;
    },

    setStripeBalance(payload) {
      this.stripe_balance = payload;
    },

    showManualPayments(payload) {
      this.manual_payments = payload;
    },

    setCompanies(payload) {
      this.companies = payload;
    },

    setStripeCompanyId(payload) {
      this.stripe_company_id = payload;
    },

    async fetch(companyId, reload = false, buyForCompanyId = null) {
      if (!this.loaded || reload) {
        this.setLoading(true);
        const response = await httpService.post(subscriptionIndexUrl(), {
          data: {
            company_id: companyId,
            buy_for_company_id: buyForCompanyId
          }
        });

        if (response.data.data.company) {
          this.form.$.company = response.data.data.company;
        }

        this.setList(response.data.data.subscriptions);
        this.setDuration(response.data.data.durations);
        this.setLatestPayments(response.data.data.latest_payments);
        this.setPaymentDetails(response.data.data.payment_method_details);
        this.setPaymentCards(response.data.data.payment_cards);
        this.setDefaultPaymentMethodId(response.data.data.default_payment_method_id);
        this.setRecurringSubscription(response.data.data.recurring_subscription);
        this.setStripeSubscription(response.data.data.stripe_subscription);
        this.setUpcomingInvoice(response.data.data.upcoming_invoice);
        this.showManualPayments(response.data.data.manual_payments);
        this.setCompanies(response.data.data.companies);
        this.setStripeCompanyId(response.data.data.stripe_company_id);
        this.show_discount = response.data.data.show_discount;
        this.vat_code = response.data.data.vat_code;
        this.vat_percent = response.data.data.vat_percent;
        this.vat_tariff = response.data.data.vat_tariff;
        this.pricing_version = response.data.data.pricing_version;
        this.setLoaded(true);
        this.setLoading(false);
      }

      return {
        list: this.list,
      };
    },
  },
});

